/* eslint-disable react/prop-types */
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import * as React from 'react';

import { cn } from './utils';

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

type OwnProps = {
  bleed?: boolean;
};

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content> & OwnProps
>(
  (
    {
      className,
      align = 'center',
      sideOffset = 4,
      bleed = false,
      asChild,
      ...props
    },
    ref,
  ) => (
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 isolate shadow-md outline-none data-[state=closed]:animate-dialogOverlayShow data-[side=bottom]:animate-slideDownAndFade data-[side=left]:animate-slideLeftAndFade data-[side=right]:animate-slideRightAndFade data-[side=top]:animate-slideUpAndFade',
        bleed ? '' : 'p-4',
        !asChild ? 'w-64 rounded-md border bg-white text-brand-black' : '',
        className,
      )}
      {...props}
      asChild={asChild}
    />
  ),
);
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent };
